// @flow
import React from 'react'
import {connect} from 'react-redux'
import ArenaCombatant from './ArenaCombatant'

class CombatantTeam extends React.Component {

  //Nudging the row up or down depending on context
  getTopValue() {
    //Mobile
    if (this.props.viewportMode === "portrait") {
      return this.props.isEnemyTeam ? "17%" : "50%"; //top row, bottom row
    }
    //Desktop
    if (this.props.viewportMode === "landscape") {
      return this.props.isEnemyTeam ? "28%" : "66%"; //top row, bottom row
    }
  }

  render() {

    const teamRowStyle = {
      position: "absolute",
      top: this.getTopValue(),
      left: 0,
      right: 0,
      zIndex: this.props.isEnemyTeam ? 1 : 2
    };

    return (
      <div style={teamRowStyle}>
        {
          this.props.combatantIds.map((combId, index) => {

            const combatantModel = this.props.combatants[combId];

            const positionData = {
              position: combatantModel.arenaPosition, //EX: 1
              totalPositions: this.props.combatantIds.length //of 3
            };

            return (
              <ArenaCombatant
                key={combId}
                model={combatantModel}
                positionData={positionData}
                isEnemyTeam={this.props.isEnemyTeam}
              />
            )
          })
        }
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    combatants: state.battle.combatants,
    viewportMode: state.global.viewportMode,
    //someProp: state.something.someProp
  }
})(CombatantTeam)


// WEBPACK FOOTER //
// ./src/battle/ArenaView/CombatantTeam.js